import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d1f5aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-cy": "inbound-template-source-row" }
const _hoisted_2 = { class: "gr-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Add template", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_unicon = _resolveComponent("el-unicon")!
  const _component_market_mapping_templates_list = _resolveComponent("market-mapping-templates-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ expanded: _ctx.isExpanded }, "gr-box-holder"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_row, {
          gutter: 10,
          class: "gr",
          type: "flex",
          align: "middle",
          onClick: $options.toggleCollapse
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  type: "flex",
                  align: "middle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 2,
                      class: "col-index"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString($props.index + 1), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_el_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: $props.row.market.logo,
                          class: "source-logo"
                        }, null, 8 /* PROPS */, _hoisted_3)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_el_col, {
                      span: 18,
                      class: "col-tpl-name"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString($props.row.market.name) + " " + _toDisplayString($props.row.marketplace ? $props.row.marketplace.locale_code : '') + " to " + _toDisplayString($props.toMapping.name), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "add-tpl-box"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($options.addMappingTemplate && $options.addMappingTemplate(...args)), ["prevent","stop"]))
                }, [
                  _createVNode(_component_el_unicon, {
                    class: "plus-icon",
                    fill: "#17B7FF",
                    name: "plus",
                    width: "16px"
                  }),
                  _hoisted_4
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "collapse-box"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_unicon, {
                  "data-cy": "source-row-expand-button",
                  fill: "#768CA3",
                  name: $options.arrowIcon,
                  width: "20px"
                }, null, 8 /* PROPS */, ["name"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ]),
      _withDirectives(_createVNode(_component_el_row, { class: "mapping-tpl-list-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_market_mapping_templates_list, {
            templates: $props.row.templates,
            "mapping-source": $props.row.marketplace,
            onOnAddTemplate: $options.addMappingTemplate,
            onOnEditTemplate: $options.editMappingTemplate,
            onOnDeleteTemplate: _cache[1] || (_cache[1] = 
            (category_id) => _ctx.$emit('onDeleteMappingTemplate', category_id)
          )
          }, null, 8 /* PROPS */, ["templates", "mapping-source", "onOnAddTemplate", "onOnEditTemplate"])
        ]),
        _: 1 /* STABLE */
      }, 512 /* NEED_PATCH */), [
        [_vShow, _ctx.isExpanded]
      ])
    ], 2 /* CLASS */)
  ]))
}